import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

export default function* splitSettlementWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_SPLIT_SETTLEMENT_CHILDREN, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_SPLIT_SETTLEMENT_CHILD, workerSaga);
  yield takeLatest(ActionConstants.GET_SPLIT_SETTLEMENT_AUDIT, workerSaga);
}
